document.addEventListener('DOMContentLoaded', () => {
    const blogsOnPage = document.querySelector('.blog-articles');
    let nextUrl = blogsOnPage.dataset.nextUrl;
    const loadMoreBtn = document.querySelector('.load-more-btn');
    const spinner = loadMoreBtn.querySelector('.loading__spinner');

    loadMoreBtn.addEventListener('click', async (e) => {
        e.preventDefault()
        spinner.classList.toggle('hidden')
        const response = await fetch(nextUrl)
        const textHtml = await response.text()

        const parser = new DOMParser()
        const newBlogs = parser.parseFromString(textHtml, 'text/html').querySelector('.blog-articles')

        blogsOnPage.insertAdjacentHTML('beforeend', newBlogs.innerHTML);
        nextUrl = newBlogs.dataset.nextUrl;
        spinner.classList.toggle('hidden')

        if (!nextUrl) {
            loadMoreBtn.classList.add('hidden');
        }
    })
})



document.addEventListener('DOMContentLoaded', function() {
  const activeTag = document.querySelector('.blog-tag.active');
  const tagsWrapper = document.querySelector('.tags-wrapper');
  if (activeTag && tagsWrapper) {
    const tagCenter = activeTag.offsetLeft + (activeTag.offsetWidth / 2);
    const wrapperCenter = tagsWrapper.offsetWidth / 2;
    tagsWrapper.scrollLeft = tagCenter - wrapperCenter;
  }
});